import React, { useEffect, useState } from "react";
import { Row, Col, Container, Accordion, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toast } from "react-toastify";
// import banner from '../components/assets/banner.mp4';

import { useLocation, useHistory } from "react-router-dom";
import { getTotalNoOfPands, getAllOpenAuctionsCount } from '../components/blockchain functions/BlockchainFunctions';
import { getUserCount } from "../components/apis/APICalls";
import { getRandomNo } from '../components/page-components/Random';
import GetNFT from '../components/page-components/getNFT';
//icons
import refresh from '../components/assets/icons/refresh.svg';
import smile from '../components/assets/icons/emoji.svg';
import auction from '../components/assets/icons/auction.svg';
import noOfUsers from '../components/assets/icons/users-user.svg';
import pandaNFT from '../components/assets/simplecroped.png';

const Home = () => {

    const history = useHistory()

    const [totalPands, setTotalPands] = useState(0);             //total number of pands NFT
    const [totalUsers, setTotalUsers] = useState(0);             //total number of pands NFT
    const [inAuctionNFTCount, setInAuctionNFTCount] = useState(0);             //total number of pands NFT

    const [NFTname, setNFTName] = useState("");             //PANDA-4023933-Y
    const [bgColor, setBgColor] = useState("");             //#E7CD4F

    useEffect(() => {
        refreshNFTName();
        updateTotalPands();
        updateTotalUsers();
        updateInAuctionNFTCount();
    }, [])

    const updateTotalPands = async () => {
        let count = await getTotalNoOfPands();
        console.log(count);
        setTotalPands(count);
    }

    const updateTotalUsers = async () => {
        let result = await getUserCount({}); //empty json for where condition
        console.log(result);
        setTotalUsers(result.count);
    }

    const updateInAuctionNFTCount = async () => {
        let count = await getAllOpenAuctionsCount();
        console.log(count);
        setInAuctionNFTCount(count);
    }

    const refreshNFTName = () => {
        let hatId = getRandomNo(7, 0)
        let eyeglassId = getRandomNo(6, 0)
        let chainId = getRandomNo(4, 0)
        let lefthandId = getRandomNo(44, 0)
        let righthandId = getRandomNo(35, 0)
        let colorRandom = getRandomNo(4, 0)
        let color;
        if (colorRandom == 0) {
            color = "R"
            setBgColor("#e74f4f");
        }
        else if (colorRandom == 1) {
            color = "G"
            setBgColor("#4CBD55");
        } else if (colorRandom == 2) {
            color = "B"
            setBgColor("#4F77E7");
        } else {
            color = "Y"
            setBgColor("#E7CD4F");
        }
        let name = "PANDA-" + hatId + eyeglassId + chainId + (lefthandId>9?lefthandId:"0"+lefthandId) + (righthandId>9?righthandId:"0"+righthandId) + "-" + color;
        console.log(name);
        setNFTName(name);
    }

    return (<>


        <Container>
            <Row className="home-heading">
                <Col md={6}>
                <div className="page-heading">
                    <h2> Welcome to MSK-Game!</h2>
                    <span> An simple, easy and cost-free NFT game to play.</span>
                    {/* <span>You can create 526,320 different NFT's.</span> */}
                    <br /><span>You can create 526,000+ different NFT's.</span>
                </div>
                </Col>
                <Col md={6}><img style={{height:"10rem",float:"right"}} src={smile} /></Col>
            </Row>

            <Row className="justify-content-md-center logo-maker-row" style={{ backgroundColor: bgColor }}>
                {/* <video src={banner} autoPlay  muted preload="metadata" Playsinline></video> */}
                <Row>
                    <Col md={3}></Col>
                    <Col md={6}>
                        <GetNFT nftName={NFTname} />
                    </Col>
                    <Col md={3}></Col>
                </Row>
                <div className="nft-mixer-text" style={{ textAlign: "center" }}>
                    <span className="nft-mixer-name-text">{NFTname}</span><br />
                    <span>NFT Name</span>
                </div>
                <hr />
                <Row className="justify-content-md-center">
                    <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip>Refresh</Tooltip>}
                        >
                    <img className="refresh-button" style={{ height: "5rem", width: "auto" }} src={refresh} onClick={refreshNFTName} />
                        </OverlayTrigger>
                </Row>
                <br /><br /><br /><br />
            </Row>

            <Row className="numbers-of-contents">
                <Col md={4}>
                    <img src={pandaNFT} />
                    <h4>Number of NFT's</h4>
                    <span className="count-value">{totalPands.toLocaleString()}</span>
                </Col>
                <Col md={4}>
                    <img src={noOfUsers} />
                    <h4>Number of User's</h4>
                    <span className="count-value">{totalUsers.toLocaleString()}</span>
                </Col>
                <Col md={4}>
                    <img src={auction} />
                    <h4>In Auction NFT</h4>
                    <span className="count-value">{inAuctionNFTCount.toLocaleString()}</span>
                </Col>
            </Row>

            <Row className="faq-div">

                <h2> FAQ's</h2>
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>What is MSK-G?</Accordion.Header>
                        <Accordion.Body>
                            It is an online, simple, and cost-free NFT game to play. Using this game,
                            you can try to play with NFTs and understand how NFT games work.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>How is it cost-free?</Accordion.Header>
                        <Accordion.Body>
                            Basically, this is a fully functional NFT game that is deployed on testnet.
                            So all the tokens are on the testnet. Hence, it does not require any cost.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Does it require an external
                            wallet to play the game?</Accordion.Header>
                        <Accordion.Body>
                            No external wallet is required as the developer takes care of all your accounts.
                            You only require an email address to create an account.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>How can I start?</Accordion.Header>
                        <Accordion.Body>
                            Click on login, you will find option for creating a new account. Enter your
                            email ID and password and click on register. Your account will be created.
                            You will get step by step details on this in <a href="#" onClick={()=>history.push('/help')}>help</a> section.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                        <Accordion.Header>Which blockchain is used?</Accordion.Header>
                        <Accordion.Body>
                            We have used WAVE blockchain for this project.
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Row>
            <br /><br /><br />

        </Container>
    </>)
}

export default Home